export const GET_GROUPS = 'app/Groups/GET_GROUPS'
export const CLEAR_GROUPS = 'app/Groups/CLEAR_GROUPS'
export const GET_GROUPS_DONE = 'app/Groups/GET_GROUPS_DONE'
export const GET_GROUPS_ERROR = 'app/Groups/GET_GROUPS_ERROR'

export const CREATE_GROUP = 'app/Groups/CREATE_GROUP'
export const CREATE_GROUP_DONE = 'app/Groups/CREATE_GROUP_DONE'
export const CREATE_GROUP_ERROR = 'app/Groups/CREATE_GROUP_ERROR'

export const UPDATE_GROUPS_BATCH = 'app/Groups/UPDATE_GROUPS_BATCH'
export const UPDATE_GROUPS_BATCH_DONE = 'app/Groups/UPDATE_GROUPS_BATCH_DONE'
export const UPDATE_GROUPS_BATCH_ERROR = 'app/Groups/UPDATE_GROUPS_BATCH_ERROR'
